import { LocationQueryValue } from 'vue-router'

export function handleParameter(parameter: string | LocationQueryValue | LocationQueryValue[]): string | null {
  if (typeof parameter === 'string') {
    return parameter
  }
  if (parameter) {
    if (isParameterArrayWithAtLeastOneValue(parameter)) {
      return parameter[0]
    }
  }
  return null
}

function isParameterArrayWithAtLeastOneValue(parameter: LocationQueryValue | LocationQueryValue[]): boolean {
  return Array.isArray(parameter) && parameter.length > 0
}